// extracted by mini-css-extract-plugin
export var width100 = "y_s d_s";
export var design3Pos = "y_tx d_X";